import { createStore } from "zustand-x"
import type { AdminDashboardSummary } from "@/domain/admin/model/AdminDashboard"

interface AdminDashboardStoreState {
  summary: AdminDashboardSummary | null
  isLoaded: boolean
  errorMessage: string
}

function makeInitAdminDashboardState(): AdminDashboardStoreState {
  return {
    summary: null,
    isLoaded: false,
    errorMessage: "",
  }
}

const AdminDashboardStore = createStore<AdminDashboardStoreState>(
  makeInitAdminDashboardState(),
  { name: "AdminDashboardStore" },
)

export { AdminDashboardStore, makeInitAdminDashboardState }
export type { AdminDashboardStoreState }
